import axios from "axios";

// Old requests must not overwrite Redux after a newer company refresh starts.
let latestRequest = 0;

export const checkedSessionAction = (url) => {
  return (dispatch) => {
    const requestId = ++latestRequest;
    dispatch({ type: "FETCH_CHECKEDSESSION_REQUEST" });
    return axios.get(url)
      .then((response) => {
        if (requestId !== latestRequest) return { ok: true, stale: true };
        dispatch({ type: "FETCH_CHECKEDSESSION_SUCCESS", payload: response.data.checked });
        return { ok: true };
      })
      .catch((error) => {
        if (requestId !== latestRequest) return { ok: true, stale: true };
        dispatch({ type: "FETCH_CHECKEDSESSION_FAILURE", payload: error.message });
        // Preserve existing UI error action without unhandled promise rejections.
        return { ok: false, error };
      });
  };
};
